<template>
<tr v-bind:class="{ expired: expire }">
    <td scope="row">
        <input type="checkbox" :value="getUrl" @change="getChecked" :checked="getCheckedState" />
    </td>
    <td>
        <router-link :to="{ name: 'Main', params: { id: getUrl } }">{{
        getPid
      }}</router-link>
    </td>
    <td>
        {{ getTitle }}

        <span v-if="project.iot == 1"><img src="@/assets/img/sim.png" alt="" /></span>
        <span v-if="project.equipment == 0"><img src="@/assets/img/computer.png" alt="" /></span>
        <span v-if="project.equipment == 2"><img src="@/assets/img/smart.png" alt="" /></span>
    </td>

    <td class="left">{{ getCapacity }}</td>
    <td v-if="info.data">{{ getWatt }}</td>
    <td v-else>-</td>
    <td v-if="info.data">{{ getToday }}</td>
    <td v-else>-</td>
    <td v-if="info.data">{{ getTodayEfficient }}</td>
    <td v-else>-</td>
    <td v-if="info.data">{{ getTotal() }}</td>
    <td v-else>-</td>
    <td>{{ getDay() }}</td>
    <td v-if="info.data">{{ getEfficient() }}</td>
    <td v-else>-</td>
    <td>{{ project.date }}</td>
    <td>{{ getCountdown() }}</td>
    <td class="flot">
        <flot v-bind:points="project.curve" v-bind:total_watt="project.total_watt" v-bind:pid="project.pid"></flot>
    </td>
</tr>
</template>

<script>
import flot from "@/components/Flot";
import moment from "moment";
export default {
    name: "detail",
    components: {
        flot,
    },
    props: ["project", "checked"],
    data() {
        return {
            info: this.project,
            day: "",
            expire: false,
        };
    },
    computed: {
        getUrl: function () {
            return this.info.pid;
        },
        getPid: function () {
            return this.info.pid.substr(4);
        },
        getTitle: function () {
            return this.info.location + this.info.name;
        },
        getCapacity: function () {
            return this.info.total_watt.toFixed(3);
        },
        getWatt: function () {
            return (this.info.data.watt_dc / 1000).toFixed(2) + " kw";
        },
        getToday: function () {
            return (this.info.data.kwh_today / 1000).toFixed(2) + " 度";
        },
        getTodayEfficient: function () {
            return (this.info.data.kwh_today / 1000 / this.info.total_watt).toFixed(
                2
            );
        },
        getCheckedState: function () {
            if (this.checked.indexOf(this.info.pid) != -1) {
                return true;
            } else {
                return false;
            }
        },
    },
    methods: {
        getDay: function () {
            var today = moment();
            var before = moment(this.info.date);
            var day = today.diff(before, "days");
            this.day = day;

            return day + "天";
        },
        getCountdown: function () {
            var today = moment();
            var expire = moment(this.info.expiration_date);
            var day = expire.diff(today, "days") + 1;

            if (day <= 45) {
                this.expire = true;
            }

            return day + "天";
        },
        getTotal: function () {
            if (!this.info.increase.original) {
                return parseInt(this.info.data.kwh_total);
            } else {
                return (
                    parseInt(this.info.data.kwh_total) +
                    parseInt(this.info.increase.original) -
                    parseInt(this.info.increase.new)
                );
            }
        },
        getEfficient: function () {
            return (this.getTotal() / this.day / this.info.total_watt).toFixed(2);
        },
        getChecked: function () {
            this.$emit("getChecked", this.getUrl);
        },
    },
};
</script>

<style lang="scss" scoped>
.left {
    text-align: left;
    padding-left: 2vw;
}

.flot .chart {
    height: 60px;
    width: 90px;
    margin: 0 auto;
}

img {
    height: 20px;
}

.expired {
    color: red;
}
</style>
